import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import PageTitle from '../../components/common/PageTitle';
import { Mail, RefreshCw } from 'lucide-react';

const VerifyEmailPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';
  const [isResending, setIsResending] = useState(false);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleResendEmail = async () => {
    if (!email) {
      setMessage('Email address not found. Please try signing up again.');
      return;
    }
    
    setIsResending(true);
    
    try {
      const { error } = await supabase.auth.resend({
        type: 'signup',
        email
      });
      
      if (error) throw error;
      
      setMessage('Verification email resent. Please check your inbox.');
    } catch (error: any) {
      setMessage(`Error: ${error.message || 'Failed to resend verification email'}`);
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div className="container-custom py-12">
      <PageTitle title="Verify Your Email" />
      
      <div className="max-w-md mx-auto bg-white rounded-lg shadow-md p-8">
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 rounded-full bg-primary-100 flex items-center justify-center">
            <Mail size={32} className="text-primary-600" />
          </div>
        </div>
        
        <h2 className="text-2xl font-serif font-bold text-center mb-2">Verify Your Email</h2>
        
        <p className="text-center mb-6 text-neutral-600">
          We've sent a verification link to{' '}
          <span className="font-medium">{email || 'your email address'}</span>.
          Please check your inbox and click the link to complete your registration.
        </p>
        
        {message && (
          <div className="mb-6 p-3 bg-blue-50 text-blue-700 rounded-md border border-blue-100">
            {message}
          </div>
        )}
        
        <div className="flex flex-col gap-4">
          <button
            onClick={handleResendEmail}
            disabled={isResending}
            className="btn btn-outline w-full flex items-center justify-center"
          >
            {isResending ? (
              <>
                <RefreshCw size={18} className="animate-spin mr-2" />
                Resending...
              </>
            ) : (
              <>
                <RefreshCw size={18} className="mr-2" />
                Resend Verification Email
              </>
            )}
          </button>
          
          <button
            onClick={() => navigate('/login')}
            className="btn btn-primary w-full"
          >
            Back to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailPage;